import Home from '@/views/Home.vue'
import Enroll from '@/views/Enroll.vue'
import Conversation from '@/views/Conversation.vue'
import Agent from '@/views/Agent.vue'
import ManageEnrollment from '@/views/ManageEnrollment.vue'
import EmployeeLogin from '@/views/EmployeeLogin.vue'
import EmployeeOnboarding from '@/views/EmployeeOnboarding.vue'
import {useCatchAllCheck} from '@/composables/use-catch-all-check.js'

//Routes
export const routes = [

  //Home
  {
    name: 'home',
    path: '/',
    component: Home,
  },

  //Enroll
  {
    name: 'enroll',
    path: '/enroll',
    component: Enroll,
  },

  //Manage enrollment
  {
    name: 'manage-enrollment',
    path: '/enrollments/:enrollmentId/details',
    component: ManageEnrollment,
  },

  //Conversation views
  {
    name: 'conversation.enrollment',
    path: '/conversation/enrollment/:enrollmentId',
    component: Conversation,
  },
  {
    name: 'conversation.channel',
    path: '/conversation/channel/:channelId',
    component: Conversation,
  },

  //Agent conversation (employee-facing name "Arist Agent"; the backend feature
  //is internally named "teammate" — see constants/teammate.js)
  {
    name: 'agent',
    path: '/agent',
    component: Agent,
  },

  //Employee ID (external_id) based login portal (for COATS etc)
  {
    name: 'employee-login',
    path: '/employee-login',
    component: EmployeeLogin,
    meta: {
      isEmployeePortal: true,
      skipAuth: true,
    },
  },

  //Post employee login onboarding step
  {
    name: 'employee-onboarding',
    path: '/employee-onboarding',
    component: EmployeeOnboarding,
    meta: {
      isEmployeePortal: true,
    },
  },

  //Catch-all redirect
  {
    name: 'catch-all',
    path: '/:pathMatch(.*)*',
    beforeEnter: () => {
      const {setCatchAll} = useCatchAllCheck()
      setCatchAll(true)
      return {name: 'home'}
    },
  },
]
